import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/Main';

var smoothScroll = require('smoothscroll');
function updateMenu() {
    let i;
    let scrollTop = window.pageYOffset;
    let items = document.getElementById('navigation-links').children;
    let itemHrefs = [];
    let sections = [];
    for (i = 0; i < items.length; i++) {
        let item = items[i];
        let id = item.href.substring(item.href.indexOf('#') + 1, item.href.length);
        let target = document.getElementById(id);

        if(target) {
            itemHrefs.push(id);
            sections.push(target);
        }
    }

    for (i = sections.length-1; i >= 0; i--) {
        let section = sections[i];
        if (section.offsetTop <= scrollTop + window.innerHeight / 2) {
            let activeElements = document.getElementsByClassName('active');
            if (activeElements.length > 0) {
              activeElements[0].classList.remove('active');
            }
            items[i].classList.add('active');
            if (i != 0) {
              if (document.getElementById('header-logo').classList.contains('hidden')) {
                document.getElementById('header-logo').classList.remove('hidden');
              }
            } else {
              if (!document.getElementById('header-logo').classList.contains('hidden')) {
                document.getElementById('header-logo').classList.add('hidden');
              }
            }
            return;
        }
    }

}

// Render the main component into the dom
ReactDOM.render(<App />, document.getElementById('app'));

window.addEventListener('resize', updateMenu);
window.addEventListener('scroll', updateMenu);
updateMenu();



// WEBPACK FOOTER //
// ./src/index.js